module.exports = __webpack_public_path__ + "img/delivery_engineer_horn.0cac0e5b.svg";